"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var RadioButtonWrapper = /** @class */ (function (_super) {
    __extends(RadioButtonWrapper, _super);
    function RadioButtonWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RadioButtonWrapper.prototype.findNativeInput = function () {
        return this.find('.awsui-radio-native-input');
    };
    RadioButtonWrapper.prototype.findLabel = function () {
        return this.find('.awsui-radio-button-label');
    };
    RadioButtonWrapper.prototype.findDescription = function () {
        return this.find('.awsui-radio-button-description');
    };
    return RadioButtonWrapper;
}(dom_1.ComponentWrapper));
exports.default = RadioButtonWrapper;
//# sourceMappingURL=awsui-radio-button.js.map